
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"M23.517 12.265c0-.986-.08-1.706-.253-2.453H11.998v4.453h6.613c-.133 1.106-.853 2.773-2.453 3.893l-.023.149 3.562 2.759.247.025c2.266-2.094 3.573-5.173 3.573-8.826","fill":"#4285F4"}}),_c('path',{attrs:{"d":"M11.998 23.997c3.24 0 5.96-1.067 7.946-2.906l-3.786-2.933c-1.013.706-2.373 1.2-4.16 1.2-3.172 0-5.865-2.094-6.825-4.987l-.141.012-3.704 2.867-.048.134c1.973 3.92 6.026 6.613 10.718 6.613","fill":"#34A853"}}),_c('path',{attrs:{"d":"M5.173 14.371a7.387 7.387 0 01-.4-2.373c0-.826.146-1.626.386-2.373l-.006-.159-3.75-2.912-.123.058A12.01 12.01 0 000 11.998c0 1.933.467 3.76 1.28 5.386l3.893-3.013","fill":"#FBBC05"}}),_c('path',{attrs:{"d":"M11.998 4.64c2.253 0 3.773.973 4.64 1.786l3.386-3.306C17.944 1.187 15.238 0 11.998 0 7.306 0 3.253 2.693 1.28 6.612l3.88 3.013c.973-2.893 3.666-4.986 6.838-4.986","fill":"#EB4335"}})])])
          )
        }
      }
    